import React from "react";
import { Link } from "react-router-dom";

import bgImg from "../../assets/img/footer/bg-1-1.jpg";
import Logo from "../../assets/img/logo/logo-white.png";

const Footer = (props) => {
  const { footerClass, footerLogo, copyrightTextClass } = props;

  return (
    <footer>
      <div
        className={
          footerClass
            ? footerClass
            : "it-footer-area it-footer-bg black-bg pt-50 pb-0"
        }
        style={{ backgroundImage: `url(${bgImg})` }}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-xl-4 col-lg-4 col-md-12 col-sm-12 mb-50 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <div className="it-footer-widget footer-col-1">
                <div className="it-footer-logo pb-25">
                  <Link to="/">
                    <img src={footerLogo ? footerLogo : Logo} alt="" />
                  </Link>
                </div>
                <div className="it-footer-text pb-5">
                  <p>
                    Society of Aquaculture Professionals was founded as a
                    not-for-profit, non-governmental organization in 2003. SAP
                    is the voice of aquaculture professionals in India and
                    presently counts 600+ life members.
                  </p>
                </div>
                <div className="it-footer-social">
                  <a
                    target="_blank"
                    href="https://www.facebook.com/p/Society-of-Aquaculture-Professionals-100063913875757/"
                  >
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/company/aquaprofessional"
                  >
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-xl-8 col-lg-8 col-md-12 col-sm-12 mb-50 wow animate__fadeInUp mt-desktop"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              {/* Quick Links Heading (Full Width) */}
              <div className="row">
                <div
                  className="col-12 mb-10 wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".5s"
                >
                  <div className="it-footer-widget footer-col-2">
                    <h4 className="it-footer-title pt-10">Quick Links:</h4>
                  </div>
                </div>
              </div>

              {/* 4 Columns Row */}
              <div className="row">
                {/* Column 1 */}
                <div
                  className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6 mb-10 wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".5s"
                >
                  <div className="it-footer-widget footer-col-4">
                    <div className="it-footer-list">
                      <ul>
                        <li>
                          <a href="news">
                            <i className="fa-regular fa-angle-right"></i>News
                          </a>
                        </li>
                        <li>
                          <a href="event">
                            <i className="fa-regular fa-angle-right"></i>Events
                          </a>
                        </li>
                        <li>
                          <a href="jobs">
                            <i className="fa-regular fa-angle-right"></i>Jobs
                          </a>
                        </li>
                        <li>
                          <a href="education">
                            <i className="fa-regular fa-angle-right"></i>
                            Education
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Column 2 */}
                <div
                  className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6 mb-10 wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".6s"
                >
                  <div className="it-footer-widget footer-col-4">
                    <div className="it-footer-list">
                      <ul>
                        <li>
                          <a href="mission">
                            <i className="fa-regular fa-angle-right"></i>Mission
                          </a>
                        </li>
                        <li>
                          <a href="strategic-partners">
                            <i className="fa-regular fa-angle-right"></i>
                            Strategic Partners
                          </a>
                        </li>
                        <li>
                          <a href="leadership">
                            <i className="fa-regular fa-angle-right"></i>
                            Leadership
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fa-regular fa-angle-right"></i>
                            Newsletter
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Column 3 */}
                <div
                  className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6 mb-10 wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".7s"
                >
                  <div className="it-footer-widget footer-col-4">
                    <div className="it-footer-list">
                      <ul>
                        <li>
                          <a href="members">
                            <i className="fa-regular fa-angle-right"></i>Members
                          </a>
                        </li>
                        <li>
                          <a href="signup">
                            <i className="fa-regular fa-angle-right"></i>Members
                            Registration
                          </a>
                        </li>
                        <li>
                          <a href="login">
                            <i className="fa-regular fa-angle-right"></i>Members
                            Login
                          </a>
                        </li>
                        <li>
                          <a href="contact">
                            <i className="fa-regular fa-angle-right"></i>Contact
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Column 4 */}
                <div
                  className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6 mb-10 wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".8s"
                >
                  <div className="it-footer-widget footer-col-4">
                    <div className="it-footer-list">
                      <ul>
                        <li>
                          <a href="privacy-policy">
                            <i className="fa-regular fa-angle-right"></i>Privacy
                            Policy
                          </a>
                        </li>
                        <li>
                          <a href="terms-conditions">
                            <i className="fa-regular fa-angle-right"></i>Terms &
                            Conditions
                          </a>
                        </li>
                        <li>
                          <a href="refund-policy">
                            <i className="fa-regular fa-angle-right"></i>Refund
                            Policy
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="it-copyright-area it-copyright-height">
        <div className="container">
          <div className="row">
            <div
              className="col-12 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <div
                className={
                  copyrightTextClass
                    ? copyrightTextClass
                    : "it-copyright-text text-center"
                }
              >
                <p>
                  Copyright &copy; 2025.All Rights Reserved{" "}
                  <a href="#">Society of Aquaculture Professionals </a> ||
                  Developed by <span>Bigg Web</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
